var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { EGDSHeading, EGDSSubheading, EGDSText } from '@egds/react-core/text';
import { EGDSSpacing } from '@egds/react-core/spacing';
function GetHeadingLabel(text) {
    return (React.createElement(EGDSHeading, { tag: "h2", size: 5 }, text));
}
function GetLinkLabel(text) {
    return (React.createElement(EGDSText, { size: 300 },
        React.createElement("div", { className: "custom-menu-text-link" }, text)));
}
function GetTextLabel(text) {
    return React.createElement(EGDSText, { theme: "default", size: 300 }, text);
}
function GetSubHeadingLabel(text) {
    return React.createElement(EGDSSubheading, null, text);
}
var PaddingWrapper = function (_a) {
    var paddingProps = _a.paddingProps, children = _a.children;
    return (React.createElement(EGDSSpacing, { padding: paddingProps },
        React.createElement("div", null, children)));
};
export var GcHeaderCustomMenuLabel = function (_a) {
    var text = _a.text, type = _a.type, iconName = _a.iconName, padding = _a.padding;
    if (!text) {
        return null;
    }
    var _b = padding || {}, _c = _b.top, top = _c === void 0 ? false : _c, _d = _b.bottom, bottom = _d === void 0 ? false : _d, _e = _b.left, left = _e === void 0 ? false : _e, _f = _b.right, right = _f === void 0 ? false : _f;
    var paddingProps = __assign(__assign(__assign(__assign({}, top ? { blockstart: 'one' } : {}), bottom ? { blockend: 'one' } : {}), left ? { inlinestart: 'one' } : {}), right ? { inlineend: 'one' } : {});
    var renderLabel = {
        HEADING: GetHeadingLabel(text),
        LINK: GetLinkLabel(text),
        SUBHEADING: GetSubHeadingLabel(text),
        TEXT: GetTextLabel(text)
    };
    return React.createElement(PaddingWrapper, { paddingProps: paddingProps }, renderLabel[type || 'TEXT']);
};
GcHeaderCustomMenuLabel.displayName = 'GcHeaderCustomMenuLabel';
//# sourceMappingURL=gc-header-custom-menu-label.js.map